/** 조기폐차 대상차량 확인(차량상태확인)서 - 별지 제3호 서식 */

const EarlyScrapVehicleClass = {
  AUTOMOBILE: 'AUTOMOBILE',
  CONSTRUCTION_MACHINERY: 'CONSTRUCTION_MACHINERY',
};

const EARLY_SCRAP_VEHICLE_CLASS_LABELS = {
  [EarlyScrapVehicleClass.AUTOMOBILE]: '자동차',
  [EarlyScrapVehicleClass.CONSTRUCTION_MACHINERY]: '건설기계',
};

const EarlyScrapConfirmationMethod = {
  ONLINE: 'ONLINE',
  ONSITE: 'ONSITE',
};

const EARLY_SCRAP_CONFIRMATION_METHOD_LABELS = {
  [EarlyScrapConfirmationMethod.ONLINE]:
    '온라인 대상차량확인 시스템(escar.or.kr)이용자: 시스템에 등록된 동영상으로 갈음',
  [EarlyScrapConfirmationMethod.ONSITE]:
    '현장 확인 : 사진 4매(전ㆍ후ㆍ좌ㆍ우면)',
};

const EarlyScrapIdentityResult = {
  MATCH: 'MATCH',
  MISMATCH: 'MISMATCH',
  UNIDENTIFIABLE: 'UNIDENTIFIABLE',
};

const EARLY_SCRAP_IDENTITY_RESULT_LABELS = {
  [EarlyScrapIdentityResult.MATCH]: '일치',
  [EarlyScrapIdentityResult.MISMATCH]: '불일치',
  [EarlyScrapIdentityResult.UNIDENTIFIABLE]: '식별불가',
};

const EarlyScrapOperationResult = {
  OK: 'OK',
  NG: 'NG',
};

const EARLY_SCRAP_OPERATION_RESULT_LABELS = {
  [EarlyScrapOperationResult.OK]: '가능',
  [EarlyScrapOperationResult.NG]: '불가',
};

const EarlyScrapPowerTransmissionResult = {
  OK: 'OK',
  NG: 'NG',
  FORWARD_REVERSE_NG: 'FORWARD_REVERSE_NG',
};

const EARLY_SCRAP_POWER_TRANSMISSION_RESULT_LABELS = {
  [EarlyScrapPowerTransmissionResult.OK]: '가능',
  [EarlyScrapPowerTransmissionResult.NG]: '불가',
  [EarlyScrapPowerTransmissionResult.FORWARD_REVERSE_NG]:
    '전진 또는 후진 불가',
};

const EarlyScrapConditionResult = {
  GOOD: 'GOOD',
  BAD: 'BAD',
};

const EARLY_SCRAP_CONDITION_RESULT_LABELS = {
  [EarlyScrapConditionResult.GOOD]: '양호',
  [EarlyScrapConditionResult.BAD]: '불량',
};

const EarlyScrapHydraulicResult = {
  GOOD: 'GOOD',
  BAD: 'BAD',
  SIMPLE_BAD_OIL: 'SIMPLE_BAD_OIL',
};

const EARLY_SCRAP_HYDRAULIC_RESULT_LABELS = {
  [EarlyScrapHydraulicResult.GOOD]: '양호',
  [EarlyScrapHydraulicResult.BAD]: '불량',
  [EarlyScrapHydraulicResult.SIMPLE_BAD_OIL]: '단순 불량(유압유부족)',
};

const EarlyScrapWorkingPartResult = {
  GOOD: 'GOOD',
  BAD: 'BAD',
  SIMPLE_BAD: 'SIMPLE_BAD',
};

const EARLY_SCRAP_WORKING_PART_RESULT_LABELS = {
  [EarlyScrapWorkingPartResult.GOOD]: '양호',
  [EarlyScrapWorkingPartResult.BAD]: '불량',
  [EarlyScrapWorkingPartResult.SIMPLE_BAD]: '단순 불량',
};

const EarlyScrapWorkingPartNoiseResult = {
  GOOD: 'GOOD',
  BAD: 'BAD',
  SIMPLE_BAD_NOISE: 'SIMPLE_BAD_NOISE',
};

const EARLY_SCRAP_WORKING_PART_NOISE_RESULT_LABELS = {
  [EarlyScrapWorkingPartNoiseResult.GOOD]: '양호',
  [EarlyScrapWorkingPartNoiseResult.BAD]: '불량',
  [EarlyScrapWorkingPartNoiseResult.SIMPLE_BAD_NOISE]: '단순 불량(소음)',
};

const EarlyScrapExteriorResult = {
  GOOD: 'GOOD',
  BAD: 'BAD',
  PARTIAL_DAMAGE: 'PARTIAL_DAMAGE',
};

const EARLY_SCRAP_EXTERIOR_RESULT_LABELS = {
  [EarlyScrapExteriorResult.GOOD]: '양호',
  [EarlyScrapExteriorResult.BAD]: '불량',
  [EarlyScrapExteriorResult.PARTIAL_DAMAGE]: '일부 파손(찌그러짐)',
};

const EarlyScrapGlassResult = {
  GOOD: 'GOOD',
  BAD: 'BAD',
  SIMPLE_DAMAGE: 'SIMPLE_DAMAGE',
};

const EARLY_SCRAP_GLASS_RESULT_LABELS = {
  [EarlyScrapGlassResult.GOOD]: '양호',
  [EarlyScrapGlassResult.BAD]: '불량',
  [EarlyScrapGlassResult.SIMPLE_DAMAGE]: '단순 파손(일부파손)',
};

const EarlyScrapTireResult = {
  GOOD: 'GOOD',
  BAD: 'BAD',
  SIMPLE_BAD_AIR: 'SIMPLE_BAD_AIR',
};

const EARLY_SCRAP_TIRE_RESULT_LABELS = {
  [EarlyScrapTireResult.GOOD]: '양호',
  [EarlyScrapTireResult.BAD]: '불량',
  [EarlyScrapTireResult.SIMPLE_BAD_AIR]: '단순 불량(공기압부족)',
};

const EarlyScrapLightingResult = {
  INSTALLED: 'INSTALLED',
  NOT_INSTALLED: 'NOT_INSTALLED',
  SIMPLE_DAMAGE: 'SIMPLE_DAMAGE',
};

const EARLY_SCRAP_LIGHTING_RESULT_LABELS = {
  [EarlyScrapLightingResult.INSTALLED]: '설치',
  [EarlyScrapLightingResult.NOT_INSTALLED]: '미설치',
  [EarlyScrapLightingResult.SIMPLE_DAMAGE]: '단순 파손(일부 깨짐)',
};

const EarlyScrapOperationalJudgment = {
  PASS: 'PASS',
  FAIL: 'FAIL',
};

const EARLY_SCRAP_OPERATIONAL_JUDGMENT_LABELS = {
  [EarlyScrapOperationalJudgment.PASS]: '가 (합격/정상가동)',
  [EarlyScrapOperationalJudgment.FAIL]: '부 (불합격/가동불능)',
};

const EarlyScrapPhotoPosition = {
  FRONT: 'FRONT',
  REAR: 'REAR',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

const EARLY_SCRAP_PHOTO_POSITION_LABELS = {
  [EarlyScrapPhotoPosition.FRONT]: '전면',
  [EarlyScrapPhotoPosition.REAR]: '후면',
  [EarlyScrapPhotoPosition.LEFT]: '좌면',
  [EarlyScrapPhotoPosition.RIGHT]: '우면',
};

Object.freeze(EarlyScrapVehicleClass);
Object.freeze(EarlyScrapConfirmationMethod);
Object.freeze(EarlyScrapIdentityResult);
Object.freeze(EarlyScrapOperationResult);
Object.freeze(EarlyScrapPowerTransmissionResult);
Object.freeze(EarlyScrapConditionResult);
Object.freeze(EarlyScrapHydraulicResult);
Object.freeze(EarlyScrapWorkingPartResult);
Object.freeze(EarlyScrapWorkingPartNoiseResult);
Object.freeze(EarlyScrapExteriorResult);
Object.freeze(EarlyScrapGlassResult);
Object.freeze(EarlyScrapTireResult);
Object.freeze(EarlyScrapLightingResult);
Object.freeze(EarlyScrapOperationalJudgment);
Object.freeze(EarlyScrapPhotoPosition);

export {
  EarlyScrapVehicleClass,
  EARLY_SCRAP_VEHICLE_CLASS_LABELS,
  EarlyScrapConfirmationMethod,
  EARLY_SCRAP_CONFIRMATION_METHOD_LABELS,
  EarlyScrapIdentityResult,
  EARLY_SCRAP_IDENTITY_RESULT_LABELS,
  EarlyScrapOperationResult,
  EARLY_SCRAP_OPERATION_RESULT_LABELS,
  EarlyScrapPowerTransmissionResult,
  EARLY_SCRAP_POWER_TRANSMISSION_RESULT_LABELS,
  EarlyScrapConditionResult,
  EARLY_SCRAP_CONDITION_RESULT_LABELS,
  EarlyScrapHydraulicResult,
  EARLY_SCRAP_HYDRAULIC_RESULT_LABELS,
  EarlyScrapWorkingPartResult,
  EARLY_SCRAP_WORKING_PART_RESULT_LABELS,
  EarlyScrapWorkingPartNoiseResult,
  EARLY_SCRAP_WORKING_PART_NOISE_RESULT_LABELS,
  EarlyScrapExteriorResult,
  EARLY_SCRAP_EXTERIOR_RESULT_LABELS,
  EarlyScrapGlassResult,
  EARLY_SCRAP_GLASS_RESULT_LABELS,
  EarlyScrapTireResult,
  EARLY_SCRAP_TIRE_RESULT_LABELS,
  EarlyScrapLightingResult,
  EARLY_SCRAP_LIGHTING_RESULT_LABELS,
  EarlyScrapOperationalJudgment,
  EARLY_SCRAP_OPERATIONAL_JUDGMENT_LABELS,
  EarlyScrapPhotoPosition,
  EARLY_SCRAP_PHOTO_POSITION_LABELS,
};
